var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBigArrowLeft28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.8536 4.14645C20.0488 4.34171 20.0488 4.65829 19.8536 4.85355L10.2071 14.5L19.8536 24.1464C20.0488 24.3417 20.0488 24.6583 19.8536 24.8536C19.6583 25.0488 19.3417 25.0488 19.1464 24.8536L9.14645 14.8536C8.95118 14.6583 8.95118 14.3417 9.14645 14.1464L19.1464 4.14645C19.3417 3.95118 19.6583 3.95118 19.8536 4.14645Z",
  fill: "currentColor"
})));
export default SvgBigArrowLeft28;